<template>
  <div class="mb-4">
    <div v-if="genres.length > 0 && !fromStayPlace" class="bg-white mb-4 border border-section_border border-b-0 rounded">
      <ul>
        <li v-for="genre in genres" v-bind:key="genre.id">
          <div @click="$emit('selectGenre', genre)" class="flex items-center p-4 pr-2 border-b">
            <span class="flex-grow">{{ genre.name }}</span>
            <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" class="text-body text-opacity-50"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="places.length > 0 && !fromStayPlace" class="bg-white mb-4 border border-section_border border-b-0 rounded">
      <ul>
        <li v-for="place in places" v-bind:key="place.id">
          <div @click="selectPlace(place)" class="p-4 border-b border-section_border flex items-center">
            <svg
              class="fill-current text-gray-500 h-6 w-8 flex-shrink-0"
              version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 1006">
              <path d="M285.5.6c-27.6 2.8-39.2 4.7-59 9.9-85.3 22.2-156.3 79.8-195.8 159C.8 229.5-7.8 303 7.5 367c7.6 31.6 16.5 52.4 41.3 97 26.9 48.4 31.5 55.9 78.7 128.5 11.1 17 25.6 39.5 32.2 50 76.8 121.4 121.8 227 147.4 345.9 1.5 6.8 1.8 6.2 4.4-6.4 10.4-52.4 32.5-120.6 56.8-175.5 30.2-68.2 61.2-122.7 126-221.4 45-68.8 56.6-88.2 79.1-133.1 25.3-50.2 30.4-63.6 37-96 6.9-34 6.5-77.4-1-115-11.5-57.5-41.7-112-86-155.1C476.3 40.2 415.6 11.6 346 2.5 334.2 1 294.4-.3 285.5.6z" />
            </svg>
            <div class="flex-grow">
              <p>{{ place.name }}</p>
              <p class="text-sm text-btn_secondary">{{ place.distance / 100}}km {{ place.address }}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="bg-white border border-section_border border-b-0 rounded">
      <ul>
        <li v-for="(place, index) in googlePlaces" v-bind:key="index">
          <div @click="selectPlace(place)" class="px-4 py-2 border-b">
            <p>{{ place.name }}</p>
            <p class="text-sm text-btn_secondary">{{ place.address }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    searchWord: {
      type: String,
      required: true
    }
  },
  created: function () {
    setInterval(()=>{
      if(this.oldInput !== this.searchWord){
        this.oldInput = this.searchWord
        this.search(this.searchWord)
      }
    }, 500)
  },
  data () {
    return {
      places: [],
      genres: [],
      oldInput: "",
      fromStayPlace: false
    }
  },
  computed: {
    ...mapGetters({
      googlePlaces: 'googleMap/getPlaces'
    })
  },
  methods: {
    selectPlace: function (place) {
      this.$store.dispatch('history/add', place)
      this.$emit('openPlace', place)
    },
    search: function (word) {
      this.places = this.$store.getters['map/search'](word)
      this.genres = this.$store.getters['genres/search'](word)
      this.$store.dispatch('googleMap/fetchPlaces', word)
    }
  }
}
</script>
